var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Checkbox",class:{ selected: _vm.selected }},[(_vm.selected)?_c('Icon',{attrs:{"name":"check","icon":"fa-solid:check"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }